<pr-page-splash>
  <pt-multifactor-enrol-page />
</pr-page-splash>
